import { styled, alpha  } from "@mui/material/styles";
import {
  MenuItem,
  IconButton as MuiIconButton, Typography,
} from "@mui/material";
import Link from "next/link";

export const AccountMenuContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const LogoutWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: `${theme.space._300} 0 `,
  alignSelf: "stretch",

}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${theme.space._300} 0 `,
}));

export const StyledLinkMenuItem = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  width: "100%",
  padding: `0 ${theme.space._500}`,
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    padding: `0 ${theme.space._500}`,
}));

export const HeaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  
  gap: theme.space._300,
  marginBottom: theme.space._200,
  
  fontSize: theme.fontSizes.sm,
  fontFamily: theme.fonts.default
}));

export const UserMenuContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 0,

  "@media (max-width: 600px)": {
    padding: `${theme.space._500} ${theme.space._500} 0 `,
  }
}));

export const MenuWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  zIndex: 1,
  padding: theme.space._500,
  gap: theme.space._400,

  "@media (max-width: 600px)": {
    padding: `0`,
  }
}));

export const BottomContainer = styled('div')<{ isLoggedIn?: boolean }>(
  ({ theme, isLoggedIn }) => {{
    return {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      
      padding: `${theme.space._300} 0 `,
      
      fontSize: theme.fontSizes.sm,
      fontFamily: theme.fonts.default,

      border: `0px solid ${theme.colors["neutral.950"]}`,

      order: -1,
      borderWidth: '0 0 1px 0',

      ...(isLoggedIn && {
        order: 0,
        borderWidth: '1px 0 0 0',
      }),
    }
  }},
);

export const MenuLinkTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.fontSizes.md,
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors["neutral.50"],
  padding: `${theme.space._300} 0`,
}));


export const InfoContainer = styled("span")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.space._100,

  ".AccountMenu_username": {
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.bold
  }
}));

export const CustomIconButton = styled(MuiIconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: alpha(
      theme.colors.white,
      parseFloat(theme.opacity.light) / 100
    ),
  },
  color: theme.colors["neutral.50"],
}));
